<template>
  <div class="content-wrapper">
    <b-row>
      <b-col md="12">
        <h3 class="pb-2" style="display: inline-block;padding-right: 5px;">{{$t('Download Center')}}</h3>
      </b-col>
    </b-row>
    <b-row class="col">
      <b-table
        ref="table"
        show-empty
        hover
        small
        stacked="true"
        :items="docs"
        :fields="fields"
        :per-page="100"
      >
        <template v-slot:cell(action)="row" >
          <a target="_blank" :href="row.item.fileName" download><i style="font-size: 20px;" class="mdi mdi-download menu-icon"></i></a>
        </template>
      </b-table>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'LicensedUserForm',
  data () {
    return {
      docs: [],
      fields: [
        { key: 'name', label: this.$t('Name'), sortable: false, sortDirection: 'desc', class: 'text-left' },
        { key: 'language', label: this.$t('Language'), sortable: false, sortDirection: 'desc', class: 'text-left' },
        { key: 'lastUpdated', label: this.$t('Last Updated'), sortable: false, class: 'text-center' },
        { key: 'action', label: this.$t('Download'), sortable: false, class: 'text-center' }
      ]
    }
  },
  mounted () {
    var self = this
    self.$refs.table.refresh()
    this.$firebase.storage().ref('downloadCenter').listAll().then(function (res) {
      res.items.forEach(function (itemRef) {
        // All the items under listRef.
        var url = itemRef.getDownloadURL()

        // ONLY USED TO UPDATE LANGUAGE OG EACH FILE
        // var lang = ''
        // switch (itemRef.name) {
        //   case 'Quick Guide.pdf':
        //     lang = 'English'
        //     break
        //   case 'ΕΛΛΗΝΙΚΑ - Blast Chiller Temperature Log - FORM.pdf':
        //     lang = 'Ελληνικά'
        //     break
        //   case 'Printer Manual.pdf':
        //     lang = 'English'
        //     break
        //   case 'ΕΛΛΗΝΙΚΑ - Fringe - Freezer Temperature Log - FORM.pdf':
        //     lang = 'Ελληνικά'
        //     break
        //   case 'Fringe - Freezer Temperature Log - FORM.pdf':
        //     lang = 'English'
        //     break
        // }
        // console.log('nameee ' + itemRef.name, typeof lang)
        // var metadata = {
        //   customMetadata: {
        //     'contentLanguage': lang
        //   }
        // }
        // itemRef.updateMetadata(metadata).then(function (metadata) {
        //   // Updated metadata for 'images/forest.jpg' is returned in the Promise
        //   console.log('updated metadata', metadata)
        // }).catch(function (error) {
        //   console.log('error', error)
        //   // Uh-oh, an error occurred!
        // })

        itemRef.getMetadata().then((data) => {
          console.log(data)
          var lastUpdate = moment(String(data.updated)).format('DD/MM/YYYY kk:mm')
          self.docs.push({
            name: itemRef.name,
            language: data.customMetadata.contentLanguage,
            fileName: url.i,
            lastUpdated: lastUpdate
          })
        })
      })
      // .catch(function (error) {
      // Uh-oh, an error occurred!
      // return error
      // })
    })
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DownloadCenter.vue